import { Moon, Sun } from "lucide-react"
import { useTheme } from "@/context/ThemeContext"

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme()

  return (
    <button
      onClick={toggleTheme}
      className="relative grid size-9 place-items-center rounded-full border border-slate-200 bg-white/80 text-slate-600 transition-all duration-300 hover:border-emerald-300 hover:text-emerald-700 dark:border-white/15 dark:bg-white/10 dark:text-white/70 dark:hover:border-emerald-400/50 dark:hover:text-emerald-300"
      aria-label={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
      title={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
    >
      <Sun
        className={`absolute size-[18px] transition-all duration-300 ${
          theme === "light" ? "rotate-0 scale-100 opacity-100" : "rotate-90 scale-0 opacity-0"
        }`}
      />
      <Moon
        className={`absolute size-[18px] transition-all duration-300 ${
          theme === "dark" ? "rotate-0 scale-100 opacity-100" : "-rotate-90 scale-0 opacity-0"
        }`}
      />
    </button>
  )
}
